function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    width: 0px;\n  }\n  to {\n    opacity: 1;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n    width: ",
        "px;\n  }\n  to {\n    opacity: 0;\n    width: 0px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    width: 0px;\n  }\n  to {\n    opacity: 1;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n    width: ",
        "px;\n  }\n  to {\n    opacity: 0;\n    width: 0px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    width: 0px;\n  }\n  to {\n    opacity: 1;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n    width: ",
        "px;\n  }\n  to {\n    opacity: 0;\n    width: 0px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
import { boxShadow } from "../../ThemeProvider/cssFor";
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { keyframes } from "@emotion/react";
import { rgba } from "../../../utils/styleUtils";
import { useContext } from "react";
import { CarinaContext } from "../../CarinaProvider";
var SEARCH_WIDTH_FULL = 560;
var SEARCH_WIDTH_MED = 460;
var SEARCH_WIDTH_SMALL = 'calc(100vw - 16px)';
var searchFullAnimationIn = keyframes(_templateObject(), SEARCH_WIDTH_FULL);
var searchFullAnimationOut = keyframes(_templateObject1(), SEARCH_WIDTH_FULL);
var searchMedAnimationIn = keyframes(_templateObject2(), SEARCH_WIDTH_MED);
var searchMedAnimationOut = keyframes(_templateObject3(), SEARCH_WIDTH_MED);
var searchSmallAnimationIn = keyframes(_templateObject4(), SEARCH_WIDTH_SMALL);
var searchSmallAnimationOut = keyframes(_templateObject5(), SEARCH_WIDTH_SMALL);
var searchAnimationInFade = keyframes(_templateObject6());
var searchAnimationOutFade = keyframes(_templateObject7());
function buildStyle(param, param1) {
    var depth = param.depth, borderColor = param.borderColor, backgroundColor = param.backgroundColor, size = param.size, spacing = param.spacing, animation = param.animation, font = param.font, readingDirection = param1.readingDirection, end = param1.end, start = param1.start;
    var _obj, _obj1;
    return {
        wrapper: {
            base: (_obj = {
                position: 'absolute',
                display: 'flex',
                width: SEARCH_WIDTH_FULL
            }, _defineProperty(_obj, end.upper.toLowerCase(), 0), _defineProperty(_obj, "top", 2), _defineProperty(_obj, end.direction, 0), _defineProperty(_obj, "animation", "".concat(searchFullAnimationIn, " ").concat(animation.duration[200], " ").concat(animation.productive.easeInOut.easing)), _defineProperty(_obj, "animationFillMode", 'both'), _obj),
            reducedMotionAnimateIn: {
                animation: "".concat(searchAnimationInFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing)
            },
            reducedMotionAnimateOut: {
                animation: "".concat(searchAnimationOutFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing)
            },
            animateFullOut: {
                animation: "".concat(searchFullAnimationOut, " ").concat(animation.duration[200], " ").concat(animation.productive.easeIn.easing)
            },
            animateSmallOut: {
                animation: "".concat(searchSmallAnimationOut, " ").concat(animation.duration[200], " ").concat(animation.productive.easeIn.easing)
            },
            animateMediumOut: {
                animation: "".concat(searchMedAnimationOut, " ").concat(animation.duration[200], " ").concat(animation.productive.easeIn.easing)
            },
            small: _defineProperty({
                width: SEARCH_WIDTH_SMALL,
                display: 'flex',
                alignItems: 'center',
                animation: "".concat(searchSmallAnimationIn, " ").concat(animation.duration[200], " ").concat(animation.productive.easeInOut.easing),
                position: 'absolute',
                top: 8
            }, end.upper.toLowerCase(), 16),
            medium: {
                width: SEARCH_WIDTH_MED,
                animation: "".concat(searchMedAnimationIn, " ").concat(animation.duration[200], " ").concat(animation.productive.easeInOut.easing)
            }
        },
        wrapperContainer: {
            base: (_obj1 = {}, _defineProperty(_obj1, start.margin, 4), _defineProperty(_obj1, end.margin, 4), _obj1),
            large: {
                position: 'relative'
            }
        },
        search: {
            input: {
                base: {
                    width: '100%',
                    border: "1px solid ".concat(borderColor.soft),
                    borderRadius: size.border.radius.twoX,
                    '&:focus': {
                        outline: 'none',
                        boxShadow: 'none'
                    }
                },
                iconLeft: _defineProperty({}, start.padding, spacing[8]),
                iconRight: _defineProperty({}, end.padding, '3.75rem')
            }
        },
        filters: {
            backgroundColor: backgroundColor.base,
            boxSizing: 'border-box',
            width: '100%',
            padding: 16,
            borderRadius: size.border.radius.twoX,
            boxShadow: boxShadow(depth.boxShadow.soft)
        },
        icons: {
            end: _objectSpread({}, readingDirection, _defineProperty({
                display: 'flex',
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)'
            }, end.upper.toLowerCase(), -10)),
            wrapper: _defineProperty({
                minWidth: 24
            }, start.margin, 4),
            button: {
                boxSizing: 'border-box',
                backgroundColor: 'transparent',
                borderRadius: size.border.radius.round,
                margin: 0,
                padding: 0,
                width: 24,
                height: 24,
                color: font.color.base,
                '&:hover': {
                    backgroundColor: rgba(backgroundColor.clickNeutral.hover, depth.opacity.light)
                },
                '&:active': {
                    backgroundColor: rgba(backgroundColor.clickNeutral.active, depth.opacity.light),
                    transform: animation.transform.shrink
                },
                '&:focus-visible': {
                    outline: 'none',
                    boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.base)
                },
                '&:disabled': {
                    opacity: depth.opacity.light,
                    cursor: 'default',
                    '&:hover, &:active': {
                        opacity: depth.opacity.light,
                        cursor: 'default'
                    }
                }
            },
            icon: {
                color: font.color.base,
                size: 'm',
                '&:hover': {
                    color: font.color.hover
                },
                '&:active': {
                    color: font.color.active
                }
            }
        },
        button: {
            padding: '0 16px',
            display: 'flex',
            alignItems: 'center'
        }
    };
}
export default function useStyle(param) {
    var isRtl = param.isRtl, breakpoints = param.breakpoints, isSearchOpen = param.isSearchOpen, zIndex = param.zIndex;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    if (!builtStyle) {
        return {
            searchBarStyles: {},
            endIconStyles: {},
            filtersContainerStyles: {},
            iconWrapperStyles: {},
            searchContainerStyles: {},
            smallScreenSearchButtonStyles: {},
            searchSubContainerStyles: {},
            searchButtonStyles: {},
            searchIconStyles: {}
        };
    }
    var wrapper = builtStyle.wrapper, wrapperContainer = builtStyle.wrapperContainer, button = builtStyle.button, search = builtStyle.search, filters = builtStyle.filters, icons = builtStyle.icons;
    var _obj;
    return {
        searchBarStyles: _objectSpread({}, search),
        filtersContainerStyles: _objectSpread({}, filters),
        endIconStyles: _objectSpread({}, icons.end),
        iconWrapperStyles: _objectSpread({}, icons.wrapper),
        searchContainerStyles: _objectSpread({}, wrapperContainer.base, _defineProperty({}, "@media (min-width: ".concat(breakpoints.m, "px)"), _objectSpread({}, wrapperContainer.large))),
        searchSubContainerStyles: _objectSpread({}, wrapper.base, {
            zIndex: zIndex
        }, prefersReducedMotion && wrapper.reducedMotionAnimateIn, !isSearchOpen && (prefersReducedMotion ? wrapper.reducedMotionAnimateOut : wrapper.animateFullOut), (_obj = {}, _defineProperty(_obj, "@media (max-width: ".concat(breakpoints.l, "px)"), _objectSpread({}, wrapper.medium, prefersReducedMotion && wrapper.reducedMotionAnimateIn, !isSearchOpen && (prefersReducedMotion ? wrapper.reducedMotionAnimateOut : wrapper.animateSmallOut))), _defineProperty(_obj, "@media (max-width: ".concat(breakpoints.m, "px)"), _objectSpread({}, wrapper.small, prefersReducedMotion && wrapper.reducedMotionAnimateIn, !isSearchOpen && (prefersReducedMotion ? wrapper.reducedMotionAnimateOut : wrapper.animateSmallOut))), _obj)),
        smallScreenSearchButtonStyles: button,
        searchButtonStyles: icons.button,
        searchIconStyles: icons.icon
    };
};
